<template>
  <v-container>
    <v-row class="text-center justify-center">
      <v-col sm="7" lg="5">
        <v-sheet class="sheet pa-8 mb-5" elevation="10">
          <div>
            <h1 class="mb-3">Create An Account</h1>
            <v-divider class="mb-6" />
            <v-alert dismissible outlined type="error" v-model="signupError">{{signupError}}</v-alert>
            <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
              <v-form @submit.prevent="handleSubmit(createAccount)">
                <ValidationProvider name="First Name" rules="required" v-slot="{ errors, valid }">
                  <v-text-field
                    aria-autocomplete="none"
                    autocomplete="one-time-code"
                    dense
                    outlined
                    label="First Name"
                    v-model="firstName"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </ValidationProvider>
                <ValidationProvider name="Last Name" rules="required" v-slot="{ errors, valid }">
                  <v-text-field
                    aria-autocomplete="none"
                    autocomplete="one-time-code"
                    dense
                    outlined
                    label="Last Name"
                    v-model="lastName"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </ValidationProvider>
                <ValidationProvider name="Email" rules="required|email" v-slot="{ errors, valid }">
                  <v-text-field
                    aria-autocomplete="none"
                    autocomplete="one-time-code"
                    dense
                    outlined
                    label="Email"
                    v-model="email"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </ValidationProvider>
                <ValidationProvider name="Phone Number" rules="required|min:10" v-slot="{ errors, valid }">
                  <v-text-field
                    aria-autocomplete="none"
                    autocomplete="one-time-code"
                    dense
                    outlined
                    label="Phone Number"
                    v-model="phoneNumber"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </ValidationProvider>
                <ValidationProvider name="Password" rules="required|confirmed:confirmPassword|min:8" v-slot="{ errors, valid }">
                  <v-text-field
                    aria-autocomplete="none"
                    autocomplete="one-time-code"
                    dense
                    outlined
                    label="Password"
                    v-model="password"
                    :error-messages="errors"
                    :success="valid"
                    required
                    type="password"
                  />
                </ValidationProvider>
                <ValidationProvider name="Confirm Password" rules="required" vid="confirmPassword" v-slot="{ errors, valid }">
                  <v-text-field
                    aria-autocomplete="none"
                    autocomplete="one-time-code"
                    dense
                    outlined
                    label="Confirm Password"
                    v-model="confirmPassword"
                    :error-messages="errors"
                    :success="valid"
                    required
                    type="password"
                  />
                </ValidationProvider>
                <ValidationProvider name="Preferred Studio" rules="required" v-slot="{ errors, valid }">
                  <v-select
                    autocomplete="one-time-code"
                    aria-autocomplete="none"
                    dense
                    outlined
                    label="Preferred Studio"
                    hide-details
                    v-model="preferredStudio"
                    :items="locations"
                    :loading="locationsLoading"
                    :disabled="locationsLoading"
                    item-text="attributes.name"
                    item-value="id"
                    :error-messages="errors"
                    :success="valid"
                    required />
                </ValidationProvider>
                <v-row class="align-center pt-6">
                  <v-col cols="1">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <v-checkbox
                        dense
                        required
                        v-model="marketingAllowed"
                        :error-messages="errors" />
                    </ValidationProvider>
                  </v-col>
                  <v-col class="text-left">
                    <label class="v-label theme--light">I would like to receive marketing emails and texts from Ra Yoga</label>
                  </v-col>
                </v-row>
                <v-row class="align-center">
                  <v-col cols="1">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <v-simple-checkbox
                        dense
                        required
                        v-model="signedWaiver"
                        :error-messages="errors" />
                    </ValidationProvider>
                  </v-col>
                  <v-col class="text-left">
                    <label class="v-label theme--light">I have read and agree to the <a target="_blank" href='https://rayoga.com/liability-waiver/'>Ra Yoga Waiver</a></label>
                  </v-col>
                </v-row>
                <v-btn
                  class="mt-5 mb-3"
                  type="submit"
                  color="primary"
                  block
                  depressed
                  x-large
                  :disabled="!canSignup"
                  >
                  Create Account
                </v-btn>
              </v-form>
            </ValidationObserver>
          </div>
          <v-btn @click="startTimer">start</v-btn>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate/dist/vee-validate.full'

import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'SingupView',

  components: {
    ValidationProvider,
    ValidationObserver
  },

  data() {
    return {
      firstName: null,
      lastName: null,
      email: null,
      phoneNumber: null,
      password: null,
      confirmPassword: null,
      marketingAllowed: true,
      signedWaiver: false,
      preferredStudio: null,
    }
  },

  computed: {
    ...mapGetters(['locationsLoading']),
    locations() {
      return this.$store.state.locations
    },
    signupError() {
      return this.$store.state.signupError
    },
    canSignup() {
      if (this.signedWaiver === false) return false
      return true
    }
  },

  methods: {
    createAccount() {
      //this.recaptcha();
      this.$store.dispatch('createAccount', {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        phone_number: this.phoneNumber,
        password: this.password,
        is_marketing_allowed: this.marketingAllowed,
        is_opted_in_to_sms: this.marketingAllowed,
        is_waiver_signed: this.signedWaiver,
        home_location: {
          id: this.preferredStudio,
        },
      }).then(() => {
        window.dataLayer.push({
          'event':'NewAccount',
        });
      })
    },
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha('signup')

      // Do stuff with the received token.
      console.log(token);
      const test = await axios.post(`https://ecco-api.rayoga.com/recaptcha`, {
        token,
      })
      console.log(test)
    },
    startTimer() {
      this.$store.dispatch('resetTimerStart')
    }
  },
  
  async mounted() {
    await this.$store.dispatch('getLocations')
  }
}
</script>

<style>
.sheet {
  position: relative;
  border-radius: 9px;
}

.banner-text {
  font-size: 14px;
  position: absolute;
  top: -20px;
  width: 85%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #56879a;
  color: #fff;
  padding: 2px 15px;
}

.desktop-image {
  position: absolute;
  top: 15px;
  left: 0;
  transform: translateX(-100%);
  z-index: 0;
}

@media(max-width: 1100px) {
  .desktop-image {
    display: none;
  }
}

@media(max-width: 776px) {
  .banner-text {
    font-size: 11px;
  }
}
</style>